import { defineStore } from 'pinia';
import { ref } from 'vue';

interface ErrorModalProps {
  headerText?: string;
  bodyText?: string;
  isOpen?: boolean;
}

export const useErrorModalStore = defineStore('errorModalStore', () => {
  const isOpen = ref(false);
  const headerText = ref<string>('');
  const bodyText = ref<string>('');

  const reset = (): void => {
    isOpen.value = false;
    headerText.value = '';
    bodyText.value = '';
  };

  const closeModal = (): void => {
    reset();
  };

  function showErrorModal(options: ErrorModalProps): void {
    isOpen.value = true;
    headerText.value = options.headerText || '';
    bodyText.value = options.bodyText || '';
  }

  return {
    showErrorModal,
    closeModal,
    isOpen,
    headerText,
    bodyText,
  };
});
